// import _ from "lodash";
import React from "react";
import Datasheet from "react-datasheet";
// Be sure to include styles at some point, probably during your bootstrapping
import "react-datasheet/lib/react-datasheet.css";

export default class BasicSheet extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            grid: [
                [
                    { readOnly: true, value: "" },
                    { value: "A", readOnly: true },
                    { value: "B", readOnly: true },
                    { value: "C", readOnly: true },
                    { value: "D", readOnly: true },
                    { value: "E", readOnly: true },
                    { value: "F", readOnly: true }
                ],
                [
                    { readOnly: true, value: 1 },
                    { value: 1 },
                    { value: 3 },
                    { value: 3 },
                    { value: 3 }
                ],
                [
                    { readOnly: true, value: 2 },
                    { value: 2 },
                    { value: 4 },
                    { value: 4 },
                    { value: 4 }
                ],
                [
                    { readOnly: true, value: 3 },
                    { value: 1 },
                    { value: 3 },
                    { value: 3 },
                    { value: 3 }
                ],
                [
                    { readOnly: true, value: 4 },
                    { value: 2 },
                    { value: 4 },
                    { value: 4 },
                    { value: 4 }
                ],
                [
                    { readOnly: true, value: 4 },
                    { value: 2 },
                    { value: 4 },
                    { value: 4 },
                    { value: 4 }
                ],
                [
                    { readOnly: true, value: 4 },
                    { value: 2 },
                    { value: 4 },
                    { value: 4 },
                    { value: 4 }
                ]
            ]
        };
    }
    render() {
        return (
            <Datasheet
                data={this.state.grid}
                valueRenderer={cell => cell.value}
                onContextMenu={(e, cell) =>
                    cell.readOnly ? e.preventDefault() : null
                }
                onCellsChanged={changes => {
                    const grid = this.state.grid.map(row => [...row]);
                    changes.forEach(({ row, col, value }) => {
                        grid[row][col] = { ...grid[row][col], value };
                    });
                    this.setState({ grid });
                }}
            />
        );
    }
}
